import { FormBuilder, FormGroup } from '@angular/forms';
import { Component, OnInit, ViewEncapsulation, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { ReportIncomeService } from '../report-income.service';
import { ReportIncomeEventType } from '../report-income.event.type';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { TweenMax, Quint } from 'gsap';
import { EventTypes } from '../../../shared/EventTypes';
import { ListItem } from '../../../shared/list-confirmation/model/list-item';
import { AutenticationService } from '../../../autentication/autentication.service';
import { AccountNumberPipe } from '../../../shared/account-number.pipe';
import { ThemeService } from './../../../shared/theme-service/theme.service';
import { Auth } from './../../../autentication/Auth';
import { CpfCnpjPipe } from './../../../shared/cpf-cnpj.pipe';
import { ReportIncomeModel } from './../models/report-income';

@Component({
	selector: 'app-report-income-confirmation',
	templateUrl: './report-income-confirmation.component.html',
	styleUrls: ['./report-income-confirmation.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class ReportIncomeConfirmationComponent implements OnInit, OnDestroy {

	@Input() reportIncomeData: ReportIncomeModel;
	@Input() submited = false;
	@Output() setForm: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
	@Output() setTitle: EventEmitter<any> = new EventEmitter<any>();
	@Output() showStepButtons: EventEmitter<boolean> = new EventEmitter<boolean>();

	private view = '[data-component="report-income-confirmation"]';
	private confirmList: Array<ListItem> = [];
	private sendConfirmedReport = false;
	public activeBackButton = false;
	public active = false;
	public disabled = false;
	public isAttendant = false;
	public form: FormGroup;

	constructor(private reportIncomeService: ReportIncomeService, private autenticationService: AutenticationService, private themeService: ThemeService) {}

	ngOnInit() {
		this.isAttendant = this.themeService.isAttendant();

		AppEventDispatcher.listen(ReportIncomeEventType.STEPS.REPORT_INCOME_CONFIRMATION, () => {
			this.active = true;
			this.show();

			this.showStepButtons.emit(false);
		});

		AppEventDispatcher.listen(ReportIncomeEventType.REPORT_INCOME.CONFIRM_DATA, () => {
			this.send();
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(ReportIncomeEventType.STEPS.REPORT_INCOME_CONFIRMATION);
		AppEventDispatcher.removeListener(ReportIncomeEventType.REPORT_INCOME.CONFIRM_DATA);
	}

	onSetSignatureForm(form: FormGroup) {
		this.form = form;
		this.setForm.emit(this.form);

		if (this.sendConfirmedReport) {
			this.send();
		}
	}

	show() {
		const title = 'Confirmação de solicitação do informe de rendimentos';

		this.setTitle.emit({
			title: title
		});

		AppEventDispatcher.dispatch(ReportIncomeEventType.BUTTONS, { show: true });

		this.buildConfirmList();

		TweenMax.delayedCall(.5, () => {
			const containerHeight = this.getStepHeight();
			TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut });
			TweenMax.to(this.view, .8, { delay: .4, left: 0, ease: Quint.easeOut });
		});

	}

	buildConfirmList() {
		const user = Auth.getInstance().getUser();
		this.confirmList = [];
		this.confirmList.push(new ListItem('Banco:', '613 - Omni Banco', 'cls_mask'));

		const accNumPipe = new AccountNumberPipe();
		this.confirmList.push(new ListItem('Conta:', accNumPipe.transform(user.accountNumber), 'cls_mask'));

		this.confirmList.push(new ListItem('Nome:', user.name, 'cls_mask'));

		const CP = new CpfCnpjPipe();
		this.confirmList.push(new ListItem('CPF/CNPJ:', CP.transform(user.cpfCnpj), 'cls_mask'));
		this.confirmList.push(new ListItem('Ano:',  this.reportIncomeData.year));

		this.reportIncomeData.resumeList = this.confirmList;

	}

	addAuthToken() {
		Auth.passToken = this.form.value.token ? this.form.value.token : '';
		Auth.assinaturaEletronica = this.form.value.eletronicSignature ? this.form.value.eletronicSignature : '';
	}

	send() {
		this.preload(true);
		this.submited = false;
		this.disabled = true;
		this.addAuthToken();

		this.autenticationService.sendDigitalSignature(this.form.value.eletronicSignature).subscribe(data => {

			if (data.Sucesso) {
				this.hide();
			}
		}, error => {
			this.preload(false);
			this.disabled = false;
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			TweenMax.delayedCall(.5, () => {
				const containerHeight = this.getStepHeight();
				TweenMax.to('.steps-container', .8, { height: containerHeight, ease: Quint.easeOut });
			});
		});
	}

	hide() {
		this.preload(true);
		TweenMax.delayedCall(1, () => {

			TweenMax.to(this.view, .8, {
				delay: .4, left: '-100%', ease: Quint.easeOut, onComplete: () => {
					this.active = false;
					AppEventDispatcher.dispatch(ReportIncomeEventType.STEPS.REPORT_INCOME_RESULT, { show: true });
					this.preload(false);
				}
			});
		});
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{ element: '[data-component="report-income-confirmation"] .content', show: active, delay: delay });
	}

	getStepHeight(): number {
		return $(this.view).outerHeight() + $('.buttons').outerHeight() + 60;
	}

	public getMessageConfirmedReport(message: boolean) {
		this.sendConfirmedReport = message;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/report-income/report-income-confirmation/report-income-confirmation.component.ts